import type { UserPermission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import * as userSlice from '../../data/user.slice';
import { useHasPermission } from './useHasPermission';

export const useIsSuperReaderUser = (): boolean => {
  const user = useAppSelector(userSlice.selectLoggedInUserInfo);

  const updatePermissionSelf: UserPermission = {
    resource: 'uniquesuperreader',
    action: 'updatebasic',
    scope: 'self',
  };

  const canUpdateSelf = useHasPermission(user, updatePermissionSelf);
  return canUpdateSelf;
};
